//DEfine routes

import Home from './components/Home.vue'
import Game from './components/Game.vue'


export default [
    { path: '/', component: Home },
    { path: '/start', component: Game }
]

